/*
 * vérifie si la page a été modifiée et envoie une alerte
 */
$('[data-check-update]').each(function(i, el) {

	var $this = $(this);

	var update_delay = 10 * 1000;

	window.setInterval( function() {
		$.getJSON($this.data('check-update')).done(function(data) {
			if( data ) {
				if( !$('#toasts_container #pp_' + data.hash).get().length ) {
					$('#toasts_container').append(data.content);
					$('#toasts_container #pp_' + data.hash).toast({ autohide: false }).toast('show');
					$('#toasts_container #pp_' + data.hash).on('hidden.bs.toast', function () {
						$(this).remove();
					});
				}
			}
		});
	}, update_delay );

});